import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { APIError, ErrorHelper, SnackbarService } from '@controladad/ng-base';

@Injectable({
  providedIn: 'root',
})
export class SnackbarExtendedService extends SnackbarService {
  constructor(snackbar: MatSnackBar) {
    super(snackbar);
  }

  override showServerError(serverCode: number, apiError?: APIError) {
    this.error(`${ErrorHelperExtended.getResponseErrorMessage(serverCode, apiError)}`, {
      code: serverCode,
    });
  }

}

const SERVER_ERROR = {
  0: `اشکال در اتصال، اینترنت خود را چک کنید`,
  401: `نشست شما منقضی شده، لطفا دوباره لاگین کنید`,
  403: `شما دسترسی برای ادامه ندارید`,
  404: `مقصد مورد نظر یافت نشد`,
  500: `اشکالی در سرور رخ داده`,
  503: `سرور غیر فعال میباشد`,
  default: `ارور`,
} as const;

class ErrorHelperExtended extends ErrorHelper {
  static override getServerErrorMessage(status: number) {
    return SERVER_ERROR[status as never] ?? SERVER_ERROR.default;
  }
  static override getApiErrorMessage(error: { code: number; message: string }) {
    return error.message as never;
  }
}
